<template>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="6" cy="6" r="6" fill="white"/>
        <circle cx="6" cy="9" r="1" fill="#FF5252"/>
        <rect x="5" y="2" width="2" height="5" rx="1" fill="#FF5252"/>
    </svg>
</template>

<script>
    export default {
        name: "DeliveryError"
    }
</script>

<style scoped>

</style>